import { IPeriodAmount } from '@common/models/period-amount';
import { IRootState } from '@src/redux/root.state';

export const selectPeriodAmounts = (state: IRootState): IPeriodAmount[] => state.settings.periodAmounts;
